import { render } from "./BLCardItem.vue?vue&type=template&id=48972cef"
import script from "./BLCardItem.vue?vue&type=script&lang=js"
export * from "./BLCardItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__